const actions = {
  GET_HISTORY_MEETING: "GET_HISTORY_MEETING",
  GET_HISTORY_MEETING_SUCCESS: "GET_HISTORY_MEETING_SUCCESS",
  FETCH_CONFIGS_BBM: "FETCH_CONFIGS_BBM",
  FETCH_CONFIGS_SUCCESS_BBM: "FETCH_CONFIGS_SUCCESS_BBM",
  SAVE_BBM: "SAVE_BBM",
  DELETE_BBM: "DELETE_BBM",
  FETCH_USER_LIST_BBB: "FETCH_USER_LIST_BBB",
  FETCH_USER_LIST_BBB_SUCCESS: "FETCH_USER_LIST_BBB_SUCCESS",
  END_CALL: "END_CALL",
  fetchHistory: (callBack, payload) => ({
    type: actions.GET_HISTORY_MEETING,
    callBack,
    payload,
  }),
  fetchHistoryMeetingSuccess: (data) => ({
    type: actions.GET_HISTORY_MEETING_SUCCESS,
    data,
  }),
  fetchConfigs: () => ({
    type: actions.FETCH_CONFIGS_BBM,
  }),
  saveBbm: (payload, callBack, edit, bbmParam) => ({
    type: actions.SAVE_BBM,
    payload,
    callBack,
    edit,
    bbmParam,
  }),
  deleteHistory: (id, callBack, reloadCb) => ({
    type: actions.DELETE_BBM,
    id,
    callBack,
    reloadCb,
  }),
  fetchUserList: (payload, callBack) => ({
    type: actions.FETCH_USER_LIST_BBB,
    payload,
    callBack,
  }),
  endCallApi: (id, callBack, reloadCb) => ({
    type: actions.END_CALL,
    id,
    callBack,
    reloadCb,
  }),
};
export default actions;
